import React from 'react';
import '../styles/style.css';
import { profile } from '../data/portfolio';

function About() {
    return (
        <section id="aboutme-section" className="section-wrap split-section">
            <div className="section-heading">
                <p className="eyebrow">Positioning</p>
                <h2>Engineering discipline with a designer's sense for clarity.</h2>
            </div>
            <div className="about-panel">
                <p>{profile.about}</p>
                <dl className="profile-list">
                    <div>
                        <dt>Current focus</dt>
                        <dd>EdTech product systems and sharpening AI fluency into dependable engineering leverage</dd>
                    </div>
                    <div>
                        <dt>Strengths</dt>
                        <dd>Product engineering, data workflows, and AI-accelerated delivery</dd>
                    </div>
                    <div>
                        <dt>Foundation</dt>
                        <dd>Software engineering education, design background, and U.S. Navy service</dd>
                    </div>
                </dl>
            </div>
        </section>
    );
}

export default About;
